<div class="progress-container">
  @for (step of steps; track step; let i = $index) {
  <div
    class="prog progress-{{ i }}"
    [ngClass]="{ active: i < activeStep.level }"
  >
    <div class="progress-mark"></div>
    <div class="progress-label">{{ step.key | translate }}</div>
  </div>
  }
</div>
